import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { actionCreators as mapActions } from './redux/hotel/map.meta';
import mapAnalyticsEventsMap from './redux/hotel/map.analytics';
import rootReducer from './rootReducer';
import createRootSaga from './sagas';
import { actionCreators as favouriteActions } from './redux/favourites/favourites.meta';
import { actionCreators as hotelActions } from './redux/hotel/hotel.meta';
import hotelAnalyticsEventsMap from './redux/hotel/hotel.analytics';
import filterAnalyticsEventsMap from './redux/filter/filter.analytics';
import bookingAnalyticsEventsMap from './redux/booking/booking.analytics';
import { cleverAnalyticsEvents } from './redux/clevertap/clevertap.reducer';
import { firebaseAnalyticsEvents } from './redux/firebaseAnalytics/firebaseAnalytic.reducer';
import { analyticsEvents as analyticsCommon } from './redux/analytics/analytics.reducer';
import { actionCreators as filterActions } from './redux/filter/filter.meta';
import { actionCreators as userActions } from './redux/user/user.meta';
import { actionCreators as metadataActions } from './redux/metadata/metadata.meta';
import { actionCreators as bookingActions } from './redux/booking/booking.meta';
import { actionCreators as loyaltyProgramActions } from './redux/loyaltyProgram/loyaltyProgram.meta';
import { actionCreators as analyticsActions } from './redux/analytics/analytics.meta';
import { actionCreators as clevertapActions } from './redux/clevertap/clevertap.meta';
import { actionCreators as firebaseActions } from './redux/firebaseAnalytics/firebaseAnalytic.meta';
import { actionCreators as bigpointsActions } from './redux/bigpoints/bigpoints.meta';
import { actionCreators as smartFillActions } from './redux/hotel/smartfill.meta';
import experimentClient from './experiments';

const sagaMiddleware = createSagaMiddleware();
const rootSaga = createRootSaga();
const store = createStore(rootReducer, {}, applyMiddleware(sagaMiddleware));
sagaMiddleware.run(rootSaga);

const actions = {
  hotelActions,
  filterActions,
  metadataActions,
  userActions,
  bookingActions,
  loyaltyProgramActions,
  analyticsActions,
  clevertapActions,
  firebaseActions,
  bigpointsActions,
  mapActions,
  favouriteActions,
  smartFillActions,
};

const analyticsEvents = {
  hotel: hotelAnalyticsEventsMap,
  booking: bookingAnalyticsEventsMap,
  filter: filterAnalyticsEventsMap,
  common: analyticsCommon,
  clevertap: cleverAnalyticsEvents,
  firebase: firebaseAnalyticsEvents,
  map: mapAnalyticsEventsMap,
};

export { store, actions, analyticsEvents, experimentClient };
